export default __webpack_public_path__ + "static/media/no-doc-search.f006ee47.png";